import { isProposedDocument } from '../predicates'

import { ComputedRef, computed } from 'vue'
import { StoredDocument } from '@app/application/ai_ocr_documents/types'

export const useDocumentView = (
  document: StoredDocument
): {
  viewingId: ComputedRef<string | number | undefined>
  viewingUrl: ComputedRef<string>
} => {
  const viewingId = computed<string | number | undefined>(() =>
    isProposedDocument(document) ? document.id : document.viewingId
  )

  const viewingUrl = computed(() => {
    if (!viewingId.value) {
      return ''
    }

    return window.Silverfin.Routes.document_path(
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      viewingId.value.toString(),
      {
        current_ledger_id: window.Silverfin.currentLedgerId(),
      }
    )
  })

  return {
    viewingId,
    viewingUrl,
  }
}
